export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-3b-dce2efd9db137f6813d364305d5452cc.webp";